import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { RotatingLines } from 'react-loader-spinner';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, BrowserRouter as Router, Route, Link, useLocation } from "react-router-dom";

function AdminOperator() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [allCustomer, setAllCustomer] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [visiblePasswords, setVisiblePasswords] = useState({});
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(100);

  async function fetchUserData() {
    setLoading(true);
    try {
      const response = await axios.post('https://node.cabletvpay.in/BillGenerateGetInfo');
      if (response.status === 200) {
        setAllCustomer(response.data.customer);
      }
    } catch (error) {
      console.log(error || "Error fetching data");
      setError(true);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchUserData();
  }, []);  

  const togglePasswordVisibility = (id) => {
    setVisiblePasswords(prevState => ({
      ...prevState,
      [id]: !prevState[id]
    }));
  };

  const filteredRows = allCustomer.filter((row) =>
    Object.values(row).some(value => String(value).toLowerCase().includes(searchQuery.toLowerCase()))
  );

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredRows.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filteredRows.length / rowsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  if (loading) return (
    <div className="content-wrapper dark-mode">
      <div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
        <RotatingLines visible={true} height="80" width="80" strokeColor="#f9f9ff" strokeWidth="2" animationDuration="0.75" ariaLabel="rotating-lines-loading" />
      </div>
    </div>
  );

  if (error) return (
    <div className="content-wrapper dark-mode">
      <ToastContainer theme='dark' />
      <div className="d-flex justify-content-center align-items-center" style={{ height: "73vh" }}>
        <img src="../asset/img/errorPage.jpg" alt="" style={{ height: "20rem" }} />
      </div>
    </div>
  );

  return (
    <div className="content-wrapper dark-mode">
      <div className="container-fluid px-lg-5">
        <ToastContainer theme='dark' />
        <div className="content-header px-0">
          <div className="card">
            <div className="card-header">
              <div className="d-flex justify-content-between">
                <h4 className='text-bold'>Bill Generation</h4>
                <input
                  type="search"
                  className="form-control text-navy bg-white border-secondary px-1 py-0"
                  placeholder=" Search operators here ! . . . ."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  style={{ borderRadius: "13px", maxWidth: "55%" }}
                />
              </div>
            </div>
            <div className="card-body">
              <table className="table table-striped table-bordered border-0 table-responsive-md">
                <thead className='text-navy text-capitalize text-bold' style={{ backgroundColor: "rgb(224, 224, 224)" }}>
                  <tr>
                    <th>S. No</th>
                    <th>Username</th>
                    <th>Operator ID</th>
                    <th>Password</th>
                    <th>Network</th>
                    <th>Bill Generate</th>
                  </tr>
                </thead>
                <tbody>
                  {currentRows.length > 0 ? (
                    currentRows.map((row, index) => (
                      <tr key={row.id}>
                        <td>{indexOfFirstRow + index + 1}</td>
                        <td>{row.username}</td>
                        <td>{row.opt_id}</td>
                        <td>
                          <button className='btn-sm my-1 px-3 btn-primary' onClick={() => togglePasswordVisibility(row.id)} style={{ cursor: "pointer" }}>
                            {visiblePasswords[row.id] ? row.password : "****"}
                          </button>
                        </td>
                        <td>{row.network}</td>
                        <td>
  {row.status === 'no' ? (
  <Link to={`/adminBillGenerate/${row.network}`}>
                              <button className='btn-sm btn-info'>Generate</button>
                            </Link>
  ) : (
    <span className="fw-bold text-danger d-block pt-2">Bill Generated</span>
  )}
</td>

                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="10" className="text-center">No Result Found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="card-footer">
                        <div className="d-flex justify-content-end">
                            <div className="pagination btn-group border-light">
                                <button className="btn btn-dark border-right" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} style={{ opacity: currentPage === 1 ? 0.6 : 1 }} ><i className="fas fa-backward" /></button>
                                <button onClick={() => paginate(1)} className={`btn ${currentPage === 1 ? "bg-gradient-green border-light active" : "btn-dark"} border-left`} > 1 </button>
                                {currentPage > 3 && <span className="mx-1">...</span>}
                                {Array.from({ length: 3 }, (_, i) => currentPage - 1 + i)
                                    .filter((page) => page > 1 && page < totalPages)
                                    .map((page) => (
                                        <button key={page} onClick={() => paginate(page)} className={`btn ${currentPage === page ? "bg-gradient-green border-light active" : "btn-dark"}`} style={{ fontWeight: currentPage === page ? "bold" : "normal" }} > {page} </button>
                                    ))}
                                {currentPage < totalPages - 2 && <span className="mx-1">...</span>}
                                {totalPages > 1 && (
                                    <button onClick={() => paginate(totalPages)} className={`btn ${currentPage === totalPages ? "bg-gradient-green border-light active" : "btn-dark"} border-right`} > {totalPages} </button>
                                )}
                                <button className="btn btn-dark  border-left" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} style={{ opacity: currentPage === totalPages ? 0.6 : 1 }} > <i className="fas fa-forward"></i></button>
                            </div>
                        </div>
                    </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminOperator;